export default "__VITE_PUBLIC_ASSET__726abaea__"